var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lite-nav-line" }, [
    _c(
      "div",
      {
        staticClass: "lite-nav-line-el",
        on: {
          click: function($event) {
            return _vm.goProjectsGallery()
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "lite-nav-line-el-icon flex-center" },
          [_c("SVGArrowBack", { staticClass: "lite-nav-line-el-icon-svg" })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "lite-nav-line-el-text flex-center collapsable" },
          [_vm._v("\n            Выбрать дом\n        ")]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "lite-nav-line-el",
        on: {
          click: function($event) {
            return _vm.selectDesign()
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "lite-nav-line-el-icon flex-center" },
          [_c("SVGFolder", { staticClass: "lite-nav-line-el-icon-svg" })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "lite-nav-line-el-text flex-center collapsable" },
          [_vm._v("\n            Выбрать дизайн\n        ")]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "lite-nav-line-el",
        on: {
          click: function($event) {
            return _vm.createPDF("load")
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "lite-nav-line-el-icon flex-center" },
          [_c("SVGDownload", { staticClass: "lite-nav-line-el-icon-svg" })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "lite-nav-line-el-text flex-center collapsable" },
          [_vm._v("\n            Скачать\n        ")]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "lite-nav-line-el",
        on: {
          click: function($event) {
            return _vm.createPDF("print")
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "lite-nav-line-el-icon flex-center" },
          [_c("SVGPrint2", { staticClass: "lite-nav-line-el-icon-svg" })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "lite-nav-line-el-text flex-center collapsable" },
          [_vm._v("\n            Распечатать\n        ")]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "lite-nav-line-el",
        on: {
          click: function($event) {
            return _vm.showModalShare()
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "lite-nav-line-el-icon flex-center" },
          [_c("SVGShare", { staticClass: "lite-nav-line-el-icon-svg" })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "lite-nav-line-el-text flex-center collapsable" },
          [_vm._v("\n            Поделиться\n        ")]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }